import * as React from 'react';
import { css, StyleSheet } from 'aphrodite/no-important';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../partials/link/TextLink';
import { useTheme } from '../../../../theming/useTheme';
import { HUGE_SCREEN_SIZE, MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';
import { P, semanticCSS } from '../../../../typography/semanticTags';
import { BaseUnit } from '../../../../theming/baseUnitDefinition';

const componentConfigurationKey = 'bottomFooterBar';

interface BottomFooterBarThemeProps {
  backgroundColor: string;
  baseUnit: BaseUnit;
  textColor: string;
}

export interface BottomFooterBarDataProps {
  year: number;
  rightsReservedText: string;
  poweredByLink: {
    text: string;
    href: string;
  };
}

const getBottomFooterBarStyle = ({ backgroundColor, baseUnit, textColor }: BottomFooterBarThemeProps) => StyleSheet.create({
  style: {
    color: textColor,
    padding: `${baseUnit * 0.5}px ${baseUnit}px`,
    boxSizing: 'border-box',
    [MEDIA_BREAKPOINTS.medium]: {
      textAlign: 'center',
    },
    [MEDIA_BREAKPOINTS.small]: {
      textAlign: 'center',
    },
    margin: '0 auto',
    maxWidth: `${HUGE_SCREEN_SIZE}px`,
  },
  wrapper: {
    backgroundColor,
  },
});

export const BottomFooterBar: React.FunctionComponent<BottomFooterBarDataProps> = props => {
  const themeProps = useTheme<BottomFooterBarThemeProps>(componentConfigurationKey);
  const bottomFooterBarStyle = getBottomFooterBarStyle(themeProps);
  const { textColor } = themeProps;
  const { year, rightsReservedText, poweredByLink } = props;
  const linkStyle = generateLinkStyleFromTheme({ idleColor: textColor, activeStateColor: textColor, hoverStateColor: textColor });

  return (
    <div className={css(bottomFooterBarStyle.wrapper)}>
      <P styles={semanticCSS(bottomFooterBarStyle.style)}>
        <TextLinkComponent href={poweredByLink.href} linkStyle={linkStyle} rel="noopener" target="_blank">
          {poweredByLink.text}
        </TextLinkComponent>
        {` © ${year} ${rightsReservedText}`}
      </P>
    </div>
  );
};
